import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITableHeaderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    TableSectionContext,
    useTableContext
} from "../../context";
import type {
    TableSectionContextType
} from "../../type";

const TABLE_HEADER_SECTION: TableSectionContextType = {
    section: "header",
    isLast: false
};

const TableHeader: FC<ITableHeaderProps> = ({
    children,
    style,
    ...props
}) => {
    const context = useTableContext({
        part: "Header"
    });

    const {
        shapeConfigs
    } = NCoreUIKitTheme.useContext(context?.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        background: context?.tableBackground ?? "transparent",
        isSticky: context?.isHeaderSticky ?? false,
        layers: shapeConfigs.layers
    });

    if(!context) {
        return null;
    }

    return <TableSectionContext.Provider
        value={TABLE_HEADER_SECTION}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container,
                context.isHeaderSticky ? stylesheet.sticky : undefined,
                containerDynamicStyle
            ]}
            role="rowgroup"
        >
            {children}
        </View>
    </TableSectionContext.Provider>;
};
export default TableHeader;
